<template>
  <div>
    <product-order-total></product-order-total>
    <product-order-selects></product-order-selects>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: ['product', 'selects'],
  name: 'ProductOrder',
  methods: {
    ...mapMutations('shop_card',['setItem', 'setSelected', 'setSelects'])
  },
  beforeMount () {
    this.setItem(this.product)
    if (this.selects){
      this.setSelects(this.selects)
      const currentSelect = this.selects.findIndex(({pivot}) => pivot.price === this.product.price)
      if (currentSelect !== -1){
        this.setSelected(this.selects[currentSelect])
      }else{
        this.setSelected(this.selects[0])
      }
    }
  }
}
</script>

<style scoped>

</style>
